export const getInitials = (value: string) => {
    const words = value.trim().split(/\s+/).filter(Boolean)

    if (words.length >= 2) {
        return `${words[0]?.[0] || ''}${words[1]?.[0] || ''}`.toUpperCase()
    }

    return value.slice(0, 2).toUpperCase()
}
